import { render, staticRenderFns } from "./approved_drafts.vue?vue&type=template&id=7dab7140&"
import script from "./approved_drafts.vue?vue&type=script&lang=js&"
export * from "./approved_drafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports